<template>
  <card-prime id="card-prime">
    <template #content>  
      <div id="aluno">
        <TituloComponent
          classTitulo="text-blue-800 text-2xl font-bold mb-6"
          titulo="Aluno"
          :exiberLinha="false"
        />
        <div class="formgrid grid">
          <InputTextLabel
            id="aluno-nome"
            label="Nome completo *"
            v-model.trim="v$.Interesse.Aluno.Nome.$model"
            :temErro="
              (v$.Interesse.Aluno.Nome.$invalid && submitted) ||
              v$.Interesse.Aluno.Nome.$pending.$response
            "
            classDiv="col-12 md:col-5"
            :class="{
              'p-invalid': v$.Interesse.Aluno.Nome.$invalid && submitted,
            }"
            :tamanhoMaximo="82"
          />
          <InputMaskLabel
            id="aluno-cpf"
            :label="configuracoesInteresse.configuracao.cpfObrigatorio ? 'CPF *' : 'CPF'"
            classDiv="col-12 md:col-2"
            v-model="v$.Interesse.Aluno.Cpf.$model"
            mask="999.999.999-99"
            :temErro="
              (v$.Interesse.Aluno.Cpf.$invalid && submitted) ||
              v$.Interesse.Aluno.Cpf.$pending.$response
            "
          />
          <InputMaskLabel
            id="aluno-data-nascimento"
            v-model="v$.Interesse.Aluno.DataNascimento.$model"
            :temErro="
              (v$.Interesse.Aluno.DataNascimento.$invalid && submitted) ||
              v$.Interesse.Aluno.DataNascimento.$pending.$response
            "
            :class="{
              'p-invalid': v$.Interesse.Aluno.DataNascimento.$invalid && submitted,
            }"
            label="Data de nascimento *"
            mask="99/99/9999"
            classDiv="col-12 md:col-3"
          />
          <DropDownLabel
            id="aluno-sexo"
            v-model="v$.Interesse.Aluno.Sexo.$model"
            :temErro="
              (v$.Interesse.Aluno.Sexo.$invalid && submitted) ||
              v$.Interesse.Aluno.Sexo.$pending.$response
            "
            :class="{
              'p-invalid': v$.Interesse.Aluno.Sexo.$invalid && submitted,
            }"
            label="Sexo *"
            :options="listaSexo"
            classDiv="col-12 md:col-2"
          />
        </div>
        <EnderecoComponent
          :submitted="submitted"
          v-model="Interesse.Aluno.Endereco"
        ></EnderecoComponent>
      </div>
    </template>
  </card-prime>
</template>

<script>
import { required, minLength } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { useInteresseStore } from "@/store/interesse";
import { useConfiguracoesInteresseStore } from "@/store/configuracaoInicial";
import { storeToRefs } from "pinia";
import InputTextLabel from "@/components/comuns/InputTextLabel.vue";
import InputMaskLabel from "@/components/comuns/InputMaskLabel.vue";
import DropDownLabel from "@/components/comuns/DropDownLabel.vue";
import EnderecoComponent from "@/components/detalhesInteresse/EnderecoComponent.vue";
import ValidacaoMixin from "@/mixins/validacao";
import TituloComponent from "@/components/comuns/TituloComponent.vue";
import CardPrime from "primevue/card";

const isDate = (value) => {
  return ValidacaoMixin.methods.validarData(value);
};

const cpfDeveSerValido = (value) => {
  return ValidacaoMixin.methods.validarCPF(value);
};

export default {
  name: "AlunoComponent",

  props: {
    submitted: Boolean,
  },

  components: {
    InputTextLabel,
    DropDownLabel,
    InputMaskLabel,
    EnderecoComponent,
    TituloComponent,
    CardPrime,
  },

  data: () => ({
    listaSexo: [
      { descricao: "Masculino", codigo: "M" },
      { descricao: "Feminino", codigo: "F" },
    ],
  }),

  setup() {
    const storeInteresse = useInteresseStore();
    const { Interesse } = storeToRefs(storeInteresse);
    const { configuracoesInteresse } =
      storeToRefs(useConfiguracoesInteresseStore());

    return { v$: useVuelidate(), Interesse, configuracoesInteresse };
  },
  
  validations() {
    return {
      Interesse: {
        Aluno: {
          Nome: { required },
          Cpf: {
            required: this.configuracoesInteresse.configuracao.cpfObrigatorio,
            isDate(value) {
              if (this.configuracoesInteresse.configuracao.cpfObrigatorio) {
                return cpfDeveSerValido(value);
              }
              return true; 
            },
          },
          DataNascimento: {
            required,
            minLength: minLength(10),
            isDate(value) {
              return isDate(value);
            },
          },
          Sexo: { required },
        },
      },
    };
  },
};
</script>

<style>
</style>